import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { Controller } from '@commoncore/controller/Controller';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';

import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '../constants/Constants';
import { SHARE_DC } from '../constants/ShareDCURLs';
import { moveCopyImplementation } from '../implementation/moveCopyImplementation';

export class moveCopyController extends Controller{
    public fileOperationsImplementation:any;
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    public fileOpsController:any;
    moveCopyImplementation: any;
    loggerService: any
    cleverTapEventsService: any;
  dcGroupCodePicker: DcgroupcodePickerService;
     

    public constructor(public globalService:GlobalService) {
      super(globalService)
      this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
      this.moveCopyImplementation = moveCopyImplementation.getInstance(this.globalService)
    }
    
    public static getInstance(globalService):moveCopyController{
		if(this.singleInstance == null){
			this.singleInstance = new moveCopyController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
      this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
      this.universalService=globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef();   
      this.fileOpsController = FileOperationsController.getInstance(globalService);
      this.loggerService = globalService.getLoggerServiceRef();
      this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    }


   async  setPayloadAndGetFolders(files,tabName){ 
      this.fileOperationsImplementation.setHandler(this.globalService)
      this.fileOperationsImplementation.setRequiredDataForAdding(files,tabName);
      if(tabName == 'sharedwithme'){
        this.fileOperationsImplementation.folderNames = [{"objectName":"Shared Files"}]
      } else if(tabName == 'teamfoldercopy'){
        this.fileOperationsImplementation.folderNames = [{"objectName":"Team Folder"}]
      }
      try{
        if(tabName == "sharedwithme"){
          await this.fileOpsController.getSharedWithMeFolders("%2BobjectName")
        } else if(tabName == "teamfoldercopy"){
          var result = await this.fileOpsController.getTeamFolders();
        } else if(tabName == "PrivateFolder"){
          var result = await this.fileOpsController.getPrivateFolders("%2BobjectName");
        }else{
          await this.fileOpsController.getFolders("%2BobjectName")
        }
        return this.fileOperationsImplementation.folderNames
      }catch(exc){
        this.loggerService.log("exception handled for add to JC",exc)
      }
    }

    async copyToSelectedFolder(objects){
      var url = window.location.href;
      this.universalService.showLoader = true;
      if(this.moveCopyImplementation.source == 'repo' && !url.includes('sharedbyme')){ // user selects files from repo 
        if(this.moveCopyImplementation.destination == 'repo'){ // trying to copy into repo
          return this.copyFilesFromRepoToRepo(objects);
        }else if(this.moveCopyImplementation.destination == 'teamfolder'){ // trying to copy repo into tf
          return this.copyFilesFromRepoToTF(objects);
        }else{ // trying to copy into share
          return this.copyFilesFromRepoToShare(objects);
        }
      } else if(this.moveCopyImplementation.source == 'teamfolder'){
        if(this.moveCopyImplementation.destination == 'teamfolder'){ // trying to copy tf into tf
          return this.copyFilesFromTFToTF(objects);
        }else if(this.moveCopyImplementation.destination == 'repo'){ // trying to copy tf into repo
          return this.copyFilesFromTFToRepo(objects);
        }
      } else{
        if(this.moveCopyImplementation.destination == 'repo' && !url.includes('sharedbyme')){ // trying to copy into repo 
          return this.copyFilesFromShareToRepo(objects);
        }else{ // trying to copy into share
          this.universalService.showToast(TOAST["CUT_COPY_NOT_ALLOWED"], "error");
          this.universalService.showLoader = false;
        }
      }
    }

  async copyFilesFromRepoToRepo(objects){
    var url,destinationObjectKey;
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + "/copy";
    if(this.universalService.selectedFolder == undefined){
        destinationObjectKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    }else{
        destinationObjectKey = this.universalService.selectedFolder["objectKey"];
    }
    try{    
        this.moveCopyImplementation.setHandler(this.globalService);
        var result = await this.moveCopyImplementation.copyFromRepoToRepo(url,destinationObjectKey,objects);
        return result;
    }catch(exc){
        this.loggerService.log("exception handled for copy",exc);
        return null;
    }
  }

  async copyFilesFromRepoToShare(objects){
    var url,destinationObjectKey;
    if(this.universalService.selectedFolder["shareKey"] == undefined){ // this check needs to be removed after server deployment is done
      this.universalService.selectedFolder = this.fileOperationsImplementation.folderNames[this.fileOperationsImplementation.folderNames.length - 1];
    }
    destinationObjectKey = this.universalService.selectedFolder["objectKey"];
    await this.dcGroupCodePicker.decideTypeOfShare(this.universalService.selectedFolder["shareKey"]);
    url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + "/" + this.universalService.selectedFolder["shareKey"] + ENV_CONFIG.commonUrls["copyFromRepoToShare"]   + "/" + destinationObjectKey;
    // url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + "/" + this.universalService.selectedFolder["shareKey"] + ENV_CONFIG.commonUrls["copyFromRepoToShare"]   + "/" + destinationObjectKey;
    try{
      this.moveCopyImplementation.setHandler(this.globalService);
        var result = await this.moveCopyImplementation.copyFromRepoToShare(url,objects);
        if(result["status"] == "request sent"){
          var status = this.getStatusOfCopying(result["resp"]["statusUrl"],result["resp"]["statusHost"]);
          return status;
        }else{
          return null;
        }
        
    }catch(exc){
      this.loggerService.log("exception handled for copying from repo to share",exc);
    }
  }

  async copyFilesFromShareToRepo(objects){
    var file = this.universalService.selectedNodes[0]["FullObject"]?this.universalService.selectedNodes[0]["FullObject"]:this.universalService.selectedNodes[0];
    var url,destinationObjectKey;
    if(this.universalService.selectedFolder == undefined){
        destinationObjectKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    }else{
        destinationObjectKey = this.universalService.selectedFolder["objectKey"];
    }
    await this.dcGroupCodePicker.decideTypeOfShare(file.shareKey);
    url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + "/" + file["shareKey"] + ENV_CONFIG.commonUrls["copyFromShareToRepo"]   + "?folderKey=" + destinationObjectKey;
    // url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + "/" + file["shareKey"] + ENV_CONFIG.commonUrls["copyFromShareToRepo"]   + "?folderKey=" + destinationObjectKey;
    try{    
      this.moveCopyImplementation.setHandler(this.globalService);
      var result = await this.moveCopyImplementation.copyFromShareToRepo(url,objects);
      if(result["status"] == "request sent"){
        this.fileOperationsImplementation.addToDBForMoveCopy("", "COPY");

        this.getStatusOfCopying(result["resp"]["statusUrl"],result["resp"]["statusHost"]);
      }else{
        return null;
      }
    }catch(exc){
        this.loggerService.log("exception handled for copy",exc);
        return null;
    }
  }

  //Copy Repo to Team Folder
  async copyFilesFromRepoToTF(objects) {
    var file = this.universalService.selectedNodes[0]["FullObject"]?this.universalService.selectedNodes[0]["FullObject"]:this.universalService.selectedNodes[0];
    var url,destinationObjectKey;
    if(this.universalService.selectedFolder != undefined){
        destinationObjectKey = this.universalService.selectedFolder["objectKey"];
    }
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderObjectCopyRepoToTF"];
    try{    
      this.moveCopyImplementation.setHandler(this.globalService);
      var result = await this.moveCopyImplementation.copyObjectsOfTF(url,objects);
      this.cleverTapEventsService.tfCopyRepoToTf();
      return result;
    }catch(exc){
        this.loggerService.log("exception handled for copyFilesFromRepoToTF.",exc);
        return null;
    }
  }

  //Copy Team Folder Object to Repo
  async copyFilesFromTFToRepo(objects) {
    var file = this.universalService.selectedNodes[0]["FullObject"]?this.universalService.selectedNodes[0]["FullObject"]:this.universalService.selectedNodes[0];
    var url,destinationObjectKey;
    if(this.universalService.selectedFolder != undefined){
        destinationObjectKey = this.universalService.selectedFolder["objectKey"];
    }
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderObjectCopyTFToRepo"];
    try{    
      this.moveCopyImplementation.setHandler(this.globalService);
      var result = await this.moveCopyImplementation.copyObjectsOfTF(url,objects);
      return result;
    }catch(exc){
        this.loggerService.log("exception handled for copyFilesFromTFToRepo.",exc);
        return null;
    }
  }

  //Copy Team Folder Object to Team Folder
  async copyFilesFromTFToTF(objects) {
    var file = this.universalService.selectedNodes[0]["FullObject"]?this.universalService.selectedNodes[0]["FullObject"]:this.universalService.selectedNodes[0];
    var url,destinationObjectKey;
    if(this.universalService.selectedFolder != undefined){
        destinationObjectKey = this.universalService.selectedFolder["objectKey"];
    }
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderObjectCopyTFToTF"];
    try{    
      this.moveCopyImplementation.setHandler(this.globalService);
      var result = await this.moveCopyImplementation.copyObjectsOfTF(url,objects);
      this.cleverTapEventsService.tfCopy();
      return result;
    }catch(exc){
        this.loggerService.log("exception handled for copyFilesFromTFToTF.",exc);
        return null;
    }
  }


   getStatusOfCopying(statusUrl,apiURL){
    var url = apiURL + statusUrl;
    try{
      this.moveCopyImplementation.setHandler(this.globalService);
      this.moveCopyImplementation.copyStatusInterval  = setInterval(async ()=>{
        if(this.moveCopyImplementation.retryCount < 5){
          this.moveCopyImplementation.retryCount +=  1;
          this.moveCopyImplementation.getCopyStatus(url);
        }else{
          clearInterval(this.moveCopyImplementation.copyStatusInterval);
          this.moveCopyImplementation.showCopyStatus = false;
          this.universalService.showToast(TOAST["COPY_FAILURE"], "error");
          return null;
        }
      },3000)
      
    }catch(exc){
      this.loggerService.log("exception handled for getting the status",exc);
        return null;
    }
  }





}
